import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import ClickOutHandler from 'react-onclickout'

import { Button } from 'components/Form'
import { getHexLuminance } from 'utils'

const TagsManagerUI = ({
  isOpenManager,
  setIsOpenManager,
  toggleManager,
  searchValue,
  setSearchValue,
  tags,
  tagsRef,
  buttonToggleTitle,
  buttonEventTitle,
  handleSelectTag,
  handleAddTag,
  handleUpdateTag,
  handleDeleteTag
}) => (
  <ClickOutHandler onClickOut={() => setIsOpenManager(false)}>
    <div className='task-manager'>
      <Button
        icon={isOpenManager ? (
          <i className='fa fa-times' aria-hidden='true'></i>
        ) : (
          <i className='fa fa-plus' aria-hidden='true'></i>
        )}
        value={buttonToggleTitle}
        onClick={toggleManager}
      />
      {isOpenManager && (
        <div className='task-manager__manager-modal'>
          <div className='task-manager__input-container'>
            <input type='text' placeholder={I18n.t('dashboard_search')} value={searchValue} onChange={event => setSearchValue(event.target.value)} />
            {searchValue && (
              <button onClick={() => setSearchValue('')}>
                <i className='fa fa-times' aria-hidden='true'></i>
              </button>
            )}
          </div>
          {tags.length > 0 && (
            <div ref={tagsRef} className='task-manager__tags'>
              {tags.map((tag, index) => (
                <div
                  key={index}
                  className='task-manager__tag'
                  style={{ backgroundColor: tag.color }}
                >
                  <span
                    style={{ color: getHexLuminance(tag.color) > 0.4 ? 'black' : 'white' }}
                    onClick={() => {
                      handleSelectTag(tag)
                      toggleManager()
                    }}
                  >
                    {tag.name}
                  </span>
                  <div className='task-manager__tag-options'>
                    <button onClick={() => handleUpdateTag(tag)}>
                      <i
                        className='fa fa-pencil'
                        aria-hidden='true'
                        style={{ color: getHexLuminance(tag.color) > 0.4 ? 'black' : 'white' }}
                      ></i>
                    </button>
                    <button onClick={() => handleDeleteTag(tag)}>
                      <i
                        className='fa fa-times'
                        aria-hidden='true'
                        style={{ color: getHexLuminance(tag.color) > 0.4 ? 'black' : 'white' }}
                      ></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
          <Button
            icon={<i className='fa fa-plus' aria-hidden='true'></i>}
            value={buttonEventTitle}
            onClick={handleAddTag}
          />
        </div>
      )}
    </div>
  </ClickOutHandler>
)

export default TagsManagerUI
